export const useConfirmationModalSize = (size: number) => {
  // use this function to set the global variable --confirmation-modal-width
  document.documentElement.style.setProperty('--confirmation-modal-width', `${size}px`);
};
